module.exports = __webpack_public_path__ + "static/marie_barnes-6a400f79fa35c44dc4e13e18a5c6a8a2.png";